/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Api
 * Geolop SEO·GEO Platform API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AddKeywordBody,
  Cluster,
  ClusterPage,
  CrawlStatus,
  CreateClusterBody,
  CreateClusterFromPagesBody,
  CreateDomainBody,
  CreateGlobalRuleBody,
  Domain,
  DomainStats,
  ExportDomainParams,
  ExportResult,
  GetDomainPagesParams,
  GlobalRule,
  HealthStatus,
  Keyword,
  LinkSuggestionsResponse,
  MergeClustersBody,
  MovePageBody,
  Page,
  PageDetail,
  PageLink,
  RadialClusterNode,
  RecrawlResult,
  ReorderClustersBody,
  SetFeaturedBody,
  SetFeaturedResponse,
  SuccessResponse,
  UpdateClusterBody,
  UpdateGlobalRuleBody,
  UpdatePageKeywordsBody,
  UpdatePageKeywordsResponse,
  Warning
} from './api.schemas';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getHealthCheckUrl = () => {




  return `/api/healthz`
}

/**
 * Returns server health status
 * @summary Health check
 */
export const healthCheck = async ( options?: RequestInit): Promise<HealthStatus> => {

  return customFetch<HealthStatus>(getHealthCheckUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getHealthCheckQueryKey = () => {
    return [
    `/api/healthz`
    ] as const;
    }


export const getHealthCheckQueryOptions = <TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getHealthCheckQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof healthCheck>>> = ({ signal }) => healthCheck({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData> & { queryKey: QueryKey }
}

export type HealthCheckQueryResult = NonNullable<Awaited<ReturnType<typeof healthCheck>>>
export type HealthCheckQueryError = ErrorType<unknown>


/**
 * @summary Health check
 */

export function useHealthCheck<TData = Awaited<ReturnType<typeof healthCheck>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof healthCheck>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getHealthCheckQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getListDomainsUrl = () => {




  return `/api/domains`
}

/**
 * @summary Tüm domainleri listele
 */
export const listDomains = async ( options?: RequestInit): Promise<Domain[]> => {

  return customFetch<Domain[]>(getListDomainsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDomainsQueryKey = () => {
    return [
    `/api/domains`
    ] as const;
    }


export const getListDomainsQueryOptions = <TData = Awaited<ReturnType<typeof listDomains>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDomains>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDomainsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDomains>>> = ({ signal }) => listDomains({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDomains>>, TError, TData> & { queryKey: QueryKey }
}

export type ListDomainsQueryResult = NonNullable<Awaited<ReturnType<typeof listDomains>>>
export type ListDomainsQueryError = ErrorType<unknown>


/**
 * @summary Tüm domainleri listele
 */

export function useListDomains<TData = Awaited<ReturnType<typeof listDomains>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listDomains>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListDomainsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateDomainUrl = () => {




  return `/api/domains`
}

/**
 * @summary Yeni domain ekle
 */
export const createDomain = async (createDomainBody: CreateDomainBody, options?: RequestInit): Promise<Domain> => {

  return customFetch<Domain>(getCreateDomainUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createDomainBody)
  }
);}




export const getCreateDomainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDomain>>, TError,{data: BodyType<CreateDomainBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createDomain>>, TError,{data: BodyType<CreateDomainBody>}, TContext> => {

const mutationKey = ['createDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createDomain>>, {data: BodyType<CreateDomainBody>}> = (props) => {
          const {data} = props ?? {};

          return  createDomain(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateDomainMutationResult = NonNullable<Awaited<ReturnType<typeof createDomain>>>
    export type CreateDomainMutationBody = BodyType<CreateDomainBody>
    export type CreateDomainMutationError = ErrorType<unknown>

    /**
 * @summary Yeni domain ekle
 */
export const useCreateDomain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createDomain>>, TError,{data: BodyType<CreateDomainBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createDomain>>,
        TError,
        {data: BodyType<CreateDomainBody>},
        TContext
      > => {
      return useMutation(getCreateDomainMutationOptions(options));
    }

export const getGetDomainUrl = (domainId: number,) => {




  return `/api/domains/${domainId}`
}

/**
 * @summary Domain detayı
 */
export const getDomain = async (domainId: number, options?: RequestInit): Promise<Domain> => {

  return customFetch<Domain>(getGetDomainUrl(domainId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDomainQueryKey = (domainId: number,) => {
    return [
    `/api/domains/${domainId}`
    ] as const;
    }


export const getGetDomainQueryOptions = <TData = Awaited<ReturnType<typeof getDomain>>, TError = ErrorType<void>>(domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDomainQueryKey(domainId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomain>>> = ({ signal }) => getDomain(domainId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: domainId !== null && domainId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDomain>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDomainQueryResult = NonNullable<Awaited<ReturnType<typeof getDomain>>>
export type GetDomainQueryError = ErrorType<void>


/**
 * @summary Domain detayı
 */

export function useGetDomain<TData = Awaited<ReturnType<typeof getDomain>>, TError = ErrorType<void>>(
 domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDomainQueryOptions(domainId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteDomainUrl = (domainId: number,) => {




  return `/api/domains/${domainId}`
}

/**
 * @summary Domain sil
 */
export const deleteDomain = async (domainId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteDomainUrl(domainId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteDomainMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDomain>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDomain>>, TError,{domainId: number}, TContext> => {

const mutationKey = ['deleteDomain'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDomain>>, {domainId: number}> = (props) => {
          const {domainId} = props ?? {};

          return  deleteDomain(domainId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDomainMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDomain>>>

    export type DeleteDomainMutationError = ErrorType<unknown>

    /**
 * @summary Domain sil
 */
export const useDeleteDomain = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDomain>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteDomain>>,
        TError,
        {domainId: number},
        TContext
      > => {
      return useMutation(getDeleteDomainMutationOptions(options));
    }

export const getStartCrawlUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/crawl`
}

/**
 * @summary Crawl başlat
 */
export const startCrawl = async (domainId: number, options?: RequestInit): Promise<CrawlStatus> => {

  return customFetch<CrawlStatus>(getStartCrawlUrl(domainId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getStartCrawlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCrawl>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof startCrawl>>, TError,{domainId: number}, TContext> => {

const mutationKey = ['startCrawl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof startCrawl>>, {domainId: number}> = (props) => {
          const {domainId} = props ?? {};

          return  startCrawl(domainId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type StartCrawlMutationResult = NonNullable<Awaited<ReturnType<typeof startCrawl>>>

    export type StartCrawlMutationError = ErrorType<unknown>

    /**
 * @summary Crawl başlat
 */
export const useStartCrawl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof startCrawl>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof startCrawl>>,
        TError,
        {domainId: number},
        TContext
      > => {
      return useMutation(getStartCrawlMutationOptions(options));
    }

export const getGetDomainPagesUrl = (domainId: number,
    params?: GetDomainPagesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/domains/${domainId}/pages?${stringifiedParams}` : `/api/domains/${domainId}/pages`
}

/**
 * @summary Domain sayfalarını listele
 */
export const getDomainPages = async (domainId: number,
    params?: GetDomainPagesParams, options?: RequestInit): Promise<Page[]> => {

  return customFetch<Page[]>(getGetDomainPagesUrl(domainId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDomainPagesQueryKey = (domainId: number,
    params?: GetDomainPagesParams,) => {
    return [
    `/api/domains/${domainId}/pages`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetDomainPagesQueryOptions = <TData = Awaited<ReturnType<typeof getDomainPages>>, TError = ErrorType<unknown>>(domainId: number,
    params?: GetDomainPagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainPages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDomainPagesQueryKey(domainId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomainPages>>> = ({ signal }) => getDomainPages(domainId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: domainId !== null && domainId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDomainPages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDomainPagesQueryResult = NonNullable<Awaited<ReturnType<typeof getDomainPages>>>
export type GetDomainPagesQueryError = ErrorType<unknown>


/**
 * @summary Domain sayfalarını listele
 */

export function useGetDomainPages<TData = Awaited<ReturnType<typeof getDomainPages>>, TError = ErrorType<unknown>>(
 domainId: number,
    params?: GetDomainPagesParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainPages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDomainPagesQueryOptions(domainId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetDomainClustersUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/clusters`
}

/**
 * @summary Domain cluster'larını listele
 */
export const getDomainClusters = async (domainId: number, options?: RequestInit): Promise<Cluster[]> => {

  return customFetch<Cluster[]>(getGetDomainClustersUrl(domainId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDomainClustersQueryKey = (domainId: number,) => {
    return [
    `/api/domains/${domainId}/clusters`
    ] as const;
    }


export const getGetDomainClustersQueryOptions = <TData = Awaited<ReturnType<typeof getDomainClusters>>, TError = ErrorType<unknown>>(domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainClusters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDomainClustersQueryKey(domainId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomainClusters>>> = ({ signal }) => getDomainClusters(domainId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: domainId !== null && domainId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDomainClusters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDomainClustersQueryResult = NonNullable<Awaited<ReturnType<typeof getDomainClusters>>>
export type GetDomainClustersQueryError = ErrorType<unknown>


/**
 * @summary Domain cluster'larını listele
 */

export function useGetDomainClusters<TData = Awaited<ReturnType<typeof getDomainClusters>>, TError = ErrorType<unknown>>(
 domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainClusters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDomainClustersQueryOptions(domainId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateClusterUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/clusters`
}

/**
 * @summary Yeni cluster oluştur
 */
export const createCluster = async (domainId: number,
    createClusterBody: CreateClusterBody, options?: RequestInit): Promise<Cluster> => {

  return customFetch<Cluster>(getCreateClusterUrl(domainId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createClusterBody)
  }
);}




export const getCreateClusterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCluster>>, TError,{domainId: number;data: BodyType<CreateClusterBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCluster>>, TError,{domainId: number;data: BodyType<CreateClusterBody>}, TContext> => {

const mutationKey = ['createCluster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCluster>>, {domainId: number;data: BodyType<CreateClusterBody>}> = (props) => {
          const {domainId,data} = props ?? {};

          return  createCluster(domainId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClusterMutationResult = NonNullable<Awaited<ReturnType<typeof createCluster>>>
    export type CreateClusterMutationBody = BodyType<CreateClusterBody>
    export type CreateClusterMutationError = ErrorType<unknown>

    /**
 * @summary Yeni cluster oluştur
 */
export const useCreateCluster = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCluster>>, TError,{domainId: number;data: BodyType<CreateClusterBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createCluster>>,
        TError,
        {domainId: number;data: BodyType<CreateClusterBody>},
        TContext
      > => {
      return useMutation(getCreateClusterMutationOptions(options));
    }

export const getGetDomainStatsUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/stats`
}

/**
 * @summary Domain istatistikleri (dashboard)
 */
export const getDomainStats = async (domainId: number, options?: RequestInit): Promise<DomainStats> => {

  return customFetch<DomainStats>(getGetDomainStatsUrl(domainId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDomainStatsQueryKey = (domainId: number,) => {
    return [
    `/api/domains/${domainId}/stats`
    ] as const;
    }


export const getGetDomainStatsQueryOptions = <TData = Awaited<ReturnType<typeof getDomainStats>>, TError = ErrorType<unknown>>(domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDomainStatsQueryKey(domainId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDomainStats>>> = ({ signal }) => getDomainStats(domainId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: domainId !== null && domainId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDomainStats>>, TError, TData> & { queryKey: QueryKey }
}

export type GetDomainStatsQueryResult = NonNullable<Awaited<ReturnType<typeof getDomainStats>>>
export type GetDomainStatsQueryError = ErrorType<unknown>


/**
 * @summary Domain istatistikleri (dashboard)
 */

export function useGetDomainStats<TData = Awaited<ReturnType<typeof getDomainStats>>, TError = ErrorType<unknown>>(
 domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getDomainStats>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetDomainStatsQueryOptions(domainId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getExportDomainUrl = (domainId: number,
    params?: ExportDomainParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/domains/${domainId}/export?${stringifiedParams}` : `/api/domains/${domainId}/export`
}

/**
 * @summary Domain analiz raporu export
 */
export const exportDomain = async (domainId: number,
    params?: ExportDomainParams, options?: RequestInit): Promise<ExportResult> => {

  return customFetch<ExportResult>(getExportDomainUrl(domainId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getExportDomainQueryKey = (domainId: number,
    params?: ExportDomainParams,) => {
    return [
    `/api/domains/${domainId}/export`, ...(params ? [params] : [])
    ] as const;
    }


export const getExportDomainQueryOptions = <TData = Awaited<ReturnType<typeof exportDomain>>, TError = ErrorType<unknown>>(domainId: number,
    params?: ExportDomainParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportDomain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getExportDomainQueryKey(domainId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof exportDomain>>> = ({ signal }) => exportDomain(domainId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: domainId !== null && domainId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof exportDomain>>, TError, TData> & { queryKey: QueryKey }
}

export type ExportDomainQueryResult = NonNullable<Awaited<ReturnType<typeof exportDomain>>>
export type ExportDomainQueryError = ErrorType<unknown>


/**
 * @summary Domain analiz raporu export
 */

export function useExportDomain<TData = Awaited<ReturnType<typeof exportDomain>>, TError = ErrorType<unknown>>(
 domainId: number,
    params?: ExportDomainParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof exportDomain>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getExportDomainQueryOptions(domainId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRunAnalysisUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/analyze`
}

/**
 * @summary Tüm domain için link analizi başlat
 */
export const runAnalysis = async (domainId: number, options?: RequestInit): Promise<CrawlStatus> => {

  return customFetch<CrawlStatus>(getRunAnalysisUrl(domainId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRunAnalysisMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAnalysis>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof runAnalysis>>, TError,{domainId: number}, TContext> => {

const mutationKey = ['runAnalysis'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof runAnalysis>>, {domainId: number}> = (props) => {
          const {domainId} = props ?? {};

          return  runAnalysis(domainId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RunAnalysisMutationResult = NonNullable<Awaited<ReturnType<typeof runAnalysis>>>

    export type RunAnalysisMutationError = ErrorType<unknown>

    /**
 * @summary Tüm domain için link analizi başlat
 */
export const useRunAnalysis = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof runAnalysis>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof runAnalysis>>,
        TError,
        {domainId: number},
        TContext
      > => {
      return useMutation(getRunAnalysisMutationOptions(options));
    }

export const getGetPageUrl = (pageId: number,) => {




  return `/api/pages/${pageId}`
}

/**
 * @summary Sayfa detayı
 */
export const getPage = async (pageId: number, options?: RequestInit): Promise<PageDetail> => {

  return customFetch<PageDetail>(getGetPageUrl(pageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageQueryKey = (pageId: number,) => {
    return [
    `/api/pages/${pageId}`
    ] as const;
    }


export const getGetPageQueryOptions = <TData = Awaited<ReturnType<typeof getPage>>, TError = ErrorType<void>>(pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageQueryKey(pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPage>>> = ({ signal }) => getPage(pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPage>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPageQueryResult = NonNullable<Awaited<ReturnType<typeof getPage>>>
export type GetPageQueryError = ErrorType<void>


/**
 * @summary Sayfa detayı
 */

export function useGetPage<TData = Awaited<ReturnType<typeof getPage>>, TError = ErrorType<void>>(
 pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPage>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPageQueryOptions(pageId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getRecrawlPageUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/recrawl`
}

/**
 * @summary Tek sayfayı yeniden tara
 */
export const recrawlPage = async (pageId: number, options?: RequestInit): Promise<RecrawlResult> => {

  return customFetch<RecrawlResult>(getRecrawlPageUrl(pageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRecrawlPageMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recrawlPage>>, TError,{pageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recrawlPage>>, TError,{pageId: number}, TContext> => {

const mutationKey = ['recrawlPage'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recrawlPage>>, {pageId: number}> = (props) => {
          const {pageId} = props ?? {};

          return  recrawlPage(pageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecrawlPageMutationResult = NonNullable<Awaited<ReturnType<typeof recrawlPage>>>

    export type RecrawlPageMutationError = ErrorType<unknown>

    /**
 * @summary Tek sayfayı yeniden tara
 */
export const useRecrawlPage = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recrawlPage>>, TError,{pageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recrawlPage>>,
        TError,
        {pageId: number},
        TContext
      > => {
      return useMutation(getRecrawlPageMutationOptions(options));
    }

export const getGetPageWarningsUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/warnings`
}

/**
 * @summary Sayfanın uyarıları
 */
export const getPageWarnings = async (pageId: number, options?: RequestInit): Promise<Warning[]> => {

  return customFetch<Warning[]>(getGetPageWarningsUrl(pageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageWarningsQueryKey = (pageId: number,) => {
    return [
    `/api/pages/${pageId}/warnings`
    ] as const;
    }


export const getGetPageWarningsQueryOptions = <TData = Awaited<ReturnType<typeof getPageWarnings>>, TError = ErrorType<unknown>>(pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageWarnings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageWarningsQueryKey(pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageWarnings>>> = ({ signal }) => getPageWarnings(pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageWarnings>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPageWarningsQueryResult = NonNullable<Awaited<ReturnType<typeof getPageWarnings>>>
export type GetPageWarningsQueryError = ErrorType<unknown>


/**
 * @summary Sayfanın uyarıları
 */

export function useGetPageWarnings<TData = Awaited<ReturnType<typeof getPageWarnings>>, TError = ErrorType<unknown>>(
 pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageWarnings>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPageWarningsQueryOptions(pageId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetPageKeywordsUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/keywords`
}

/**
 * @summary Sayfanın anahtar kelimeleri
 */
export const getPageKeywords = async (pageId: number, options?: RequestInit): Promise<Keyword[]> => {

  return customFetch<Keyword[]>(getGetPageKeywordsUrl(pageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageKeywordsQueryKey = (pageId: number,) => {
    return [
    `/api/pages/${pageId}/keywords`
    ] as const;
    }


export const getGetPageKeywordsQueryOptions = <TData = Awaited<ReturnType<typeof getPageKeywords>>, TError = ErrorType<unknown>>(pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageKeywords>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageKeywordsQueryKey(pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageKeywords>>> = ({ signal }) => getPageKeywords(pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageKeywords>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPageKeywordsQueryResult = NonNullable<Awaited<ReturnType<typeof getPageKeywords>>>
export type GetPageKeywordsQueryError = ErrorType<unknown>


/**
 * @summary Sayfanın anahtar kelimeleri
 */

export function useGetPageKeywords<TData = Awaited<ReturnType<typeof getPageKeywords>>, TError = ErrorType<unknown>>(
 pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageKeywords>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPageKeywordsQueryOptions(pageId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getAddKeywordUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/keywords`
}

/**
 * @summary Sayfaya anahtar kelime ekle
 */
export const addKeyword = async (pageId: number,
    addKeywordBody: AddKeywordBody, options?: RequestInit): Promise<Keyword> => {

  return customFetch<Keyword>(getAddKeywordUrl(pageId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(addKeywordBody)
  }
);}




export const getAddKeywordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addKeyword>>, TError,{pageId: number;data: BodyType<AddKeywordBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addKeyword>>, TError,{pageId: number;data: BodyType<AddKeywordBody>}, TContext> => {

const mutationKey = ['addKeyword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addKeyword>>, {pageId: number;data: BodyType<AddKeywordBody>}> = (props) => {
          const {pageId,data} = props ?? {};

          return  addKeyword(pageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddKeywordMutationResult = NonNullable<Awaited<ReturnType<typeof addKeyword>>>
    export type AddKeywordMutationBody = BodyType<AddKeywordBody>
    export type AddKeywordMutationError = ErrorType<unknown>

    /**
 * @summary Sayfaya anahtar kelime ekle
 */
export const useAddKeyword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addKeyword>>, TError,{pageId: number;data: BodyType<AddKeywordBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof addKeyword>>,
        TError,
        {pageId: number;data: BodyType<AddKeywordBody>},
        TContext
      > => {
      return useMutation(getAddKeywordMutationOptions(options));
    }

export const getUpdatePageKeywordsUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/keywords`
}

/**
 * @summary Sayfanın birincil/ikincil/hedef anahtar kelimelerini güncelle
 */
export const updatePageKeywords = async (pageId: number,
    updatePageKeywordsBody: UpdatePageKeywordsBody, options?: RequestInit): Promise<UpdatePageKeywordsResponse> => {

  return customFetch<UpdatePageKeywordsResponse>(getUpdatePageKeywordsUrl(pageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updatePageKeywordsBody)
  }
);}




export const getUpdatePageKeywordsMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePageKeywords>>, TError,{pageId: number;data: BodyType<UpdatePageKeywordsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePageKeywords>>, TError,{pageId: number;data: BodyType<UpdatePageKeywordsBody>}, TContext> => {

const mutationKey = ['updatePageKeywords'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePageKeywords>>, {pageId: number;data: BodyType<UpdatePageKeywordsBody>}> = (props) => {
          const {pageId,data} = props ?? {};

          return  updatePageKeywords(pageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePageKeywordsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePageKeywords>>>
    export type UpdatePageKeywordsMutationBody = BodyType<UpdatePageKeywordsBody>
    export type UpdatePageKeywordsMutationError = ErrorType<void>

    /**
 * @summary Sayfanın birincil/ikincil/hedef anahtar kelimelerini güncelle
 */
export const useUpdatePageKeywords = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePageKeywords>>, TError,{pageId: number;data: BodyType<UpdatePageKeywordsBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updatePageKeywords>>,
        TError,
        {pageId: number;data: BodyType<UpdatePageKeywordsBody>},
        TContext
      > => {
      return useMutation(getUpdatePageKeywordsMutationOptions(options));
    }

export const getSetPageFeaturedUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/featured`
}

/**
 * @summary Sayfayı öne çıkan içerik olarak işaretle / kaldır
 */
export const setPageFeatured = async (pageId: number,
    setFeaturedBody: SetFeaturedBody, options?: RequestInit): Promise<SetFeaturedResponse> => {

  return customFetch<SetFeaturedResponse>(getSetPageFeaturedUrl(pageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(setFeaturedBody)
  }
);}




export const getSetPageFeaturedMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPageFeatured>>, TError,{pageId: number;data: BodyType<SetFeaturedBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setPageFeatured>>, TError,{pageId: number;data: BodyType<SetFeaturedBody>}, TContext> => {

const mutationKey = ['setPageFeatured'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setPageFeatured>>, {pageId: number;data: BodyType<SetFeaturedBody>}> = (props) => {
          const {pageId,data} = props ?? {};

          return  setPageFeatured(pageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetPageFeaturedMutationResult = NonNullable<Awaited<ReturnType<typeof setPageFeatured>>>
    export type SetPageFeaturedMutationBody = BodyType<SetFeaturedBody>
    export type SetPageFeaturedMutationError = ErrorType<unknown>

    /**
 * @summary Sayfayı öne çıkan içerik olarak işaretle / kaldır
 */
export const useSetPageFeatured = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setPageFeatured>>, TError,{pageId: number;data: BodyType<SetFeaturedBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof setPageFeatured>>,
        TError,
        {pageId: number;data: BodyType<SetFeaturedBody>},
        TContext
      > => {
      return useMutation(getSetPageFeaturedMutationOptions(options));
    }

export const getGetPageLinkSuggestionsUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/link-suggestions`
}

/**
 * @summary Sayfa için iç link önerileri
 */
export const getPageLinkSuggestions = async (pageId: number, options?: RequestInit): Promise<LinkSuggestionsResponse> => {

  return customFetch<LinkSuggestionsResponse>(getGetPageLinkSuggestionsUrl(pageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageLinkSuggestionsQueryKey = (pageId: number,) => {
    return [
    `/api/pages/${pageId}/link-suggestions`
    ] as const;
    }


export const getGetPageLinkSuggestionsQueryOptions = <TData = Awaited<ReturnType<typeof getPageLinkSuggestions>>, TError = ErrorType<unknown>>(pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageLinkSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageLinkSuggestionsQueryKey(pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageLinkSuggestions>>> = ({ signal }) => getPageLinkSuggestions(pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageLinkSuggestions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPageLinkSuggestionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPageLinkSuggestions>>>
export type GetPageLinkSuggestionsQueryError = ErrorType<unknown>


/**
 * @summary Sayfa için iç link önerileri
 */

export function useGetPageLinkSuggestions<TData = Awaited<ReturnType<typeof getPageLinkSuggestions>>, TError = ErrorType<unknown>>(
 pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageLinkSuggestions>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPageLinkSuggestionsQueryOptions(pageId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getDeleteKeywordUrl = (pageId: number,
    keywordId: number,) => {




  return `/api/pages/${pageId}/keywords/${keywordId}`
}

/**
 * @summary Anahtar kelime sil
 */
export const deleteKeyword = async (pageId: number,
    keywordId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteKeywordUrl(pageId,keywordId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteKeywordMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteKeyword>>, TError,{pageId: number;keywordId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteKeyword>>, TError,{pageId: number;keywordId: number}, TContext> => {

const mutationKey = ['deleteKeyword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteKeyword>>, {pageId: number;keywordId: number}> = (props) => {
          const {pageId,keywordId} = props ?? {};

          return  deleteKeyword(pageId,keywordId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteKeywordMutationResult = NonNullable<Awaited<ReturnType<typeof deleteKeyword>>>

    export type DeleteKeywordMutationError = ErrorType<unknown>

    /**
 * @summary Anahtar kelime sil
 */
export const useDeleteKeyword = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteKeyword>>, TError,{pageId: number;keywordId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteKeyword>>,
        TError,
        {pageId: number;keywordId: number},
        TContext
      > => {
      return useMutation(getDeleteKeywordMutationOptions(options));
    }

export const getGetPageLinksUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/links`
}

/**
 * @summary Sayfanın linkleri
 */
export const getPageLinks = async (pageId: number, options?: RequestInit): Promise<PageLink[]> => {

  return customFetch<PageLink[]>(getGetPageLinksUrl(pageId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPageLinksQueryKey = (pageId: number,) => {
    return [
    `/api/pages/${pageId}/links`
    ] as const;
    }


export const getGetPageLinksQueryOptions = <TData = Awaited<ReturnType<typeof getPageLinks>>, TError = ErrorType<unknown>>(pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPageLinksQueryKey(pageId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPageLinks>>> = ({ signal }) => getPageLinks(pageId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: pageId !== null && pageId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPageLinks>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPageLinksQueryResult = NonNullable<Awaited<ReturnType<typeof getPageLinks>>>
export type GetPageLinksQueryError = ErrorType<unknown>


/**
 * @summary Sayfanın linkleri
 */

export function useGetPageLinks<TData = Awaited<ReturnType<typeof getPageLinks>>, TError = ErrorType<unknown>>(
 pageId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPageLinks>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPageLinksQueryOptions(pageId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetClusterUrl = (clusterId: number,) => {




  return `/api/clusters/${clusterId}`
}

/**
 * @summary Cluster detayı
 */
export const getCluster = async (clusterId: number, options?: RequestInit): Promise<Cluster> => {

  return customFetch<Cluster>(getGetClusterUrl(clusterId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClusterQueryKey = (clusterId: number,) => {
    return [
    `/api/clusters/${clusterId}`
    ] as const;
    }


export const getGetClusterQueryOptions = <TData = Awaited<ReturnType<typeof getCluster>>, TError = ErrorType<unknown>>(clusterId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCluster>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClusterQueryKey(clusterId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCluster>>> = ({ signal }) => getCluster(clusterId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clusterId !== null && clusterId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCluster>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClusterQueryResult = NonNullable<Awaited<ReturnType<typeof getCluster>>>
export type GetClusterQueryError = ErrorType<unknown>


/**
 * @summary Cluster detayı
 */

export function useGetCluster<TData = Awaited<ReturnType<typeof getCluster>>, TError = ErrorType<unknown>>(
 clusterId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getCluster>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClusterQueryOptions(clusterId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getUpdateClusterUrl = (clusterId: number,) => {




  return `/api/clusters/${clusterId}`
}

/**
 * @summary Cluster güncelle
 */
export const updateCluster = async (clusterId: number,
    updateClusterBody: UpdateClusterBody, options?: RequestInit): Promise<Cluster> => {

  return customFetch<Cluster>(getUpdateClusterUrl(clusterId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateClusterBody)
  }
);}




export const getUpdateClusterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCluster>>, TError,{clusterId: number;data: BodyType<UpdateClusterBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCluster>>, TError,{clusterId: number;data: BodyType<UpdateClusterBody>}, TContext> => {

const mutationKey = ['updateCluster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCluster>>, {clusterId: number;data: BodyType<UpdateClusterBody>}> = (props) => {
          const {clusterId,data} = props ?? {};

          return  updateCluster(clusterId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateClusterMutationResult = NonNullable<Awaited<ReturnType<typeof updateCluster>>>
    export type UpdateClusterMutationBody = BodyType<UpdateClusterBody>
    export type UpdateClusterMutationError = ErrorType<unknown>

    /**
 * @summary Cluster güncelle
 */
export const useUpdateCluster = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCluster>>, TError,{clusterId: number;data: BodyType<UpdateClusterBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateCluster>>,
        TError,
        {clusterId: number;data: BodyType<UpdateClusterBody>},
        TContext
      > => {
      return useMutation(getUpdateClusterMutationOptions(options));
    }

export const getDeleteClusterUrl = (clusterId: number,) => {




  return `/api/clusters/${clusterId}`
}

/**
 * @summary Cluster sil
 */
export const deleteCluster = async (clusterId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteClusterUrl(clusterId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteClusterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCluster>>, TError,{clusterId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCluster>>, TError,{clusterId: number}, TContext> => {

const mutationKey = ['deleteCluster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCluster>>, {clusterId: number}> = (props) => {
          const {clusterId} = props ?? {};

          return  deleteCluster(clusterId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteClusterMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCluster>>>

    export type DeleteClusterMutationError = ErrorType<unknown>

    /**
 * @summary Cluster sil
 */
export const useDeleteCluster = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCluster>>, TError,{clusterId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteCluster>>,
        TError,
        {clusterId: number},
        TContext
      > => {
      return useMutation(getDeleteClusterMutationOptions(options));
    }

export const getGetClusterPagesUrl = (clusterId: number,) => {




  return `/api/clusters/${clusterId}/pages`
}

/**
 * @summary Cluster içindeki sayfaları listele
 */
export const getClusterPages = async (clusterId: number, options?: RequestInit): Promise<ClusterPage[]> => {

  return customFetch<ClusterPage[]>(getGetClusterPagesUrl(clusterId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetClusterPagesQueryKey = (clusterId: number,) => {
    return [
    `/api/clusters/${clusterId}/pages`
    ] as const;
    }


export const getGetClusterPagesQueryOptions = <TData = Awaited<ReturnType<typeof getClusterPages>>, TError = ErrorType<unknown>>(clusterId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClusterPages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClusterPagesQueryKey(clusterId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClusterPages>>> = ({ signal }) => getClusterPages(clusterId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: clusterId !== null && clusterId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClusterPages>>, TError, TData> & { queryKey: QueryKey }
}

export type GetClusterPagesQueryResult = NonNullable<Awaited<ReturnType<typeof getClusterPages>>>
export type GetClusterPagesQueryError = ErrorType<unknown>


/**
 * @summary Cluster içindeki sayfaları listele
 */

export function useGetClusterPages<TData = Awaited<ReturnType<typeof getClusterPages>>, TError = ErrorType<unknown>>(
 clusterId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getClusterPages>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetClusterPagesQueryOptions(clusterId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getGetRadialClustersUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/clusters/radial`
}

/**
 * @summary Radial tree görselleştirmesi için cluster + sayfa verisi
 */
export const getRadialClusters = async (domainId: number, options?: RequestInit): Promise<RadialClusterNode[]> => {

  return customFetch<RadialClusterNode[]>(getGetRadialClustersUrl(domainId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetRadialClustersQueryKey = (domainId: number,) => {
    return [
    `/api/domains/${domainId}/clusters/radial`
    ] as const;
    }


export const getGetRadialClustersQueryOptions = <TData = Awaited<ReturnType<typeof getRadialClusters>>, TError = ErrorType<unknown>>(domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRadialClusters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRadialClustersQueryKey(domainId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRadialClusters>>> = ({ signal }) => getRadialClusters(domainId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: domainId !== null && domainId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRadialClusters>>, TError, TData> & { queryKey: QueryKey }
}

export type GetRadialClustersQueryResult = NonNullable<Awaited<ReturnType<typeof getRadialClusters>>>
export type GetRadialClustersQueryError = ErrorType<unknown>


/**
 * @summary Radial tree görselleştirmesi için cluster + sayfa verisi
 */

export function useGetRadialClusters<TData = Awaited<ReturnType<typeof getRadialClusters>>, TError = ErrorType<unknown>>(
 domainId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getRadialClusters>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetRadialClustersQueryOptions(domainId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getMovePageToClusterUrl = (pageId: number,) => {




  return `/api/pages/${pageId}/move`
}

/**
 * @summary Sayfayı başka bir cluster'a taşı (drag-and-drop)
 */
export const movePageToCluster = async (pageId: number,
    movePageBody: MovePageBody, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getMovePageToClusterUrl(pageId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(movePageBody)
  }
);}




export const getMovePageToClusterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof movePageToCluster>>, TError,{pageId: number;data: BodyType<MovePageBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof movePageToCluster>>, TError,{pageId: number;data: BodyType<MovePageBody>}, TContext> => {

const mutationKey = ['movePageToCluster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof movePageToCluster>>, {pageId: number;data: BodyType<MovePageBody>}> = (props) => {
          const {pageId,data} = props ?? {};

          return  movePageToCluster(pageId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MovePageToClusterMutationResult = NonNullable<Awaited<ReturnType<typeof movePageToCluster>>>
    export type MovePageToClusterMutationBody = BodyType<MovePageBody>
    export type MovePageToClusterMutationError = ErrorType<unknown>

    /**
 * @summary Sayfayı başka bir cluster'a taşı (drag-and-drop)
 */
export const useMovePageToCluster = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof movePageToCluster>>, TError,{pageId: number;data: BodyType<MovePageBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof movePageToCluster>>,
        TError,
        {pageId: number;data: BodyType<MovePageBody>},
        TContext
      > => {
      return useMutation(getMovePageToClusterMutationOptions(options));
    }

export const getAssignPageToClusterUrl = (clusterId: number,
    pageId: number,) => {




  return `/api/clusters/${clusterId}/pages/${pageId}`
}

/**
 * @summary Sayfayı cluster'a ata
 */
export const assignPageToCluster = async (clusterId: number,
    pageId: number, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getAssignPageToClusterUrl(clusterId,pageId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getAssignPageToClusterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignPageToCluster>>, TError,{clusterId: number;pageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof assignPageToCluster>>, TError,{clusterId: number;pageId: number}, TContext> => {

const mutationKey = ['assignPageToCluster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof assignPageToCluster>>, {clusterId: number;pageId: number}> = (props) => {
          const {clusterId,pageId} = props ?? {};

          return  assignPageToCluster(clusterId,pageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AssignPageToClusterMutationResult = NonNullable<Awaited<ReturnType<typeof assignPageToCluster>>>

    export type AssignPageToClusterMutationError = ErrorType<unknown>

    /**
 * @summary Sayfayı cluster'a ata
 */
export const useAssignPageToCluster = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof assignPageToCluster>>, TError,{clusterId: number;pageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof assignPageToCluster>>,
        TError,
        {clusterId: number;pageId: number},
        TContext
      > => {
      return useMutation(getAssignPageToClusterMutationOptions(options));
    }

export const getRemovePageFromClusterUrl = (clusterId: number,
    pageId: number,) => {




  return `/api/clusters/${clusterId}/pages/${pageId}`
}

/**
 * @summary Sayfayı cluster'dan çıkar
 */
export const removePageFromCluster = async (clusterId: number,
    pageId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getRemovePageFromClusterUrl(clusterId,pageId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getRemovePageFromClusterMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePageFromCluster>>, TError,{clusterId: number;pageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removePageFromCluster>>, TError,{clusterId: number;pageId: number}, TContext> => {

const mutationKey = ['removePageFromCluster'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removePageFromCluster>>, {clusterId: number;pageId: number}> = (props) => {
          const {clusterId,pageId} = props ?? {};

          return  removePageFromCluster(clusterId,pageId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemovePageFromClusterMutationResult = NonNullable<Awaited<ReturnType<typeof removePageFromCluster>>>

    export type RemovePageFromClusterMutationError = ErrorType<unknown>

    /**
 * @summary Sayfayı cluster'dan çıkar
 */
export const useRemovePageFromCluster = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removePageFromCluster>>, TError,{clusterId: number;pageId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof removePageFromCluster>>,
        TError,
        {clusterId: number;pageId: number},
        TContext
      > => {
      return useMutation(getRemovePageFromClusterMutationOptions(options));
    }

export const getMergeClustersUrl = () => {




  return `/api/clusters/merge`
}

/**
 * @summary Birden fazla cluster'ı birleştir
 */
export const mergeClusters = async (mergeClustersBody: MergeClustersBody, options?: RequestInit): Promise<Cluster> => {

  return customFetch<Cluster>(getMergeClustersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(mergeClustersBody)
  }
);}




export const getMergeClustersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeClusters>>, TError,{data: BodyType<MergeClustersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof mergeClusters>>, TError,{data: BodyType<MergeClustersBody>}, TContext> => {

const mutationKey = ['mergeClusters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof mergeClusters>>, {data: BodyType<MergeClustersBody>}> = (props) => {
          const {data} = props ?? {};

          return  mergeClusters(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type MergeClustersMutationResult = NonNullable<Awaited<ReturnType<typeof mergeClusters>>>
    export type MergeClustersMutationBody = BodyType<MergeClustersBody>
    export type MergeClustersMutationError = ErrorType<unknown>

    /**
 * @summary Birden fazla cluster'ı birleştir
 */
export const useMergeClusters = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof mergeClusters>>, TError,{data: BodyType<MergeClustersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof mergeClusters>>,
        TError,
        {data: BodyType<MergeClustersBody>},
        TContext
      > => {
      return useMutation(getMergeClustersMutationOptions(options));
    }

export const getCreateClusterFromPagesUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/clusters/from-pages`
}

/**
 * @summary Seçilen sayfalardan atomik olarak yeni alt-küme oluştur
 */
export const createClusterFromPages = async (domainId: number,
    createClusterFromPagesBody: CreateClusterFromPagesBody, options?: RequestInit): Promise<Cluster> => {

  return customFetch<Cluster>(getCreateClusterFromPagesUrl(domainId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createClusterFromPagesBody)
  }
);}




export const getCreateClusterFromPagesMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClusterFromPages>>, TError,{domainId: number;data: BodyType<CreateClusterFromPagesBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createClusterFromPages>>, TError,{domainId: number;data: BodyType<CreateClusterFromPagesBody>}, TContext> => {

const mutationKey = ['createClusterFromPages'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createClusterFromPages>>, {domainId: number;data: BodyType<CreateClusterFromPagesBody>}> = (props) => {
          const {domainId,data} = props ?? {};

          return  createClusterFromPages(domainId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateClusterFromPagesMutationResult = NonNullable<Awaited<ReturnType<typeof createClusterFromPages>>>
    export type CreateClusterFromPagesMutationBody = BodyType<CreateClusterFromPagesBody>
    export type CreateClusterFromPagesMutationError = ErrorType<unknown>

    /**
 * @summary Seçilen sayfalardan atomik olarak yeni alt-küme oluştur
 */
export const useCreateClusterFromPages = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createClusterFromPages>>, TError,{domainId: number;data: BodyType<CreateClusterFromPagesBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createClusterFromPages>>,
        TError,
        {domainId: number;data: BodyType<CreateClusterFromPagesBody>},
        TContext
      > => {
      return useMutation(getCreateClusterFromPagesMutationOptions(options));
    }

export const getSaveAndRecrawlUrl = (domainId: number,) => {




  return `/api/domains/${domainId}/clusters/save`
}

/**
 * @summary Cluster düzenini koruyarak siteyi yeniden tara
 */
export const saveAndRecrawl = async (domainId: number, options?: RequestInit): Promise<CrawlStatus> => {

  return customFetch<CrawlStatus>(getSaveAndRecrawlUrl(domainId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getSaveAndRecrawlMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAndRecrawl>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAndRecrawl>>, TError,{domainId: number}, TContext> => {

const mutationKey = ['saveAndRecrawl'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAndRecrawl>>, {domainId: number}> = (props) => {
          const {domainId} = props ?? {};

          return  saveAndRecrawl(domainId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SaveAndRecrawlMutationResult = NonNullable<Awaited<ReturnType<typeof saveAndRecrawl>>>

    export type SaveAndRecrawlMutationError = ErrorType<unknown>

    /**
 * @summary Cluster düzenini koruyarak siteyi yeniden tara
 */
export const useSaveAndRecrawl = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAndRecrawl>>, TError,{domainId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof saveAndRecrawl>>,
        TError,
        {domainId: number},
        TContext
      > => {
      return useMutation(getSaveAndRecrawlMutationOptions(options));
    }

export const getReorderClustersUrl = () => {




  return `/api/clusters/reorder`
}

/**
 * @summary Cluster sıralamasını güncelle
 */
export const reorderClusters = async (reorderClustersBody: ReorderClustersBody, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getReorderClustersUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(reorderClustersBody)
  }
);}




export const getReorderClustersMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderClusters>>, TError,{data: BodyType<ReorderClustersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof reorderClusters>>, TError,{data: BodyType<ReorderClustersBody>}, TContext> => {

const mutationKey = ['reorderClusters'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reorderClusters>>, {data: BodyType<ReorderClustersBody>}> = (props) => {
          const {data} = props ?? {};

          return  reorderClusters(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReorderClustersMutationResult = NonNullable<Awaited<ReturnType<typeof reorderClusters>>>
    export type ReorderClustersMutationBody = BodyType<ReorderClustersBody>
    export type ReorderClustersMutationError = ErrorType<unknown>

    /**
 * @summary Cluster sıralamasını güncelle
 */
export const useReorderClusters = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reorderClusters>>, TError,{data: BodyType<ReorderClustersBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reorderClusters>>,
        TError,
        {data: BodyType<ReorderClustersBody>},
        TContext
      > => {
      return useMutation(getReorderClustersMutationOptions(options));
    }

export const getResolveWarningUrl = (warningId: number,) => {




  return `/api/warnings/${warningId}/resolve`
}

/**
 * @summary Uyarıyı çözüldü olarak işaretle (kabul et)
 */
export const resolveWarning = async (warningId: number, options?: RequestInit): Promise<Warning> => {

  return customFetch<Warning>(getResolveWarningUrl(warningId),
  {
    ...options,
    method: 'PATCH'


  }
);}




export const getResolveWarningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveWarning>>, TError,{warningId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof resolveWarning>>, TError,{warningId: number}, TContext> => {

const mutationKey = ['resolveWarning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resolveWarning>>, {warningId: number}> = (props) => {
          const {warningId} = props ?? {};

          return  resolveWarning(warningId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResolveWarningMutationResult = NonNullable<Awaited<ReturnType<typeof resolveWarning>>>

    export type ResolveWarningMutationError = ErrorType<unknown>

    /**
 * @summary Uyarıyı çözüldü olarak işaretle (kabul et)
 */
export const useResolveWarning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resolveWarning>>, TError,{warningId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resolveWarning>>,
        TError,
        {warningId: number},
        TContext
      > => {
      return useMutation(getResolveWarningMutationOptions(options));
    }

export const getRejectWarningUrl = (warningId: number,) => {




  return `/api/warnings/${warningId}/reject`
}

/**
 * @summary AI önerisini reddet — uyarı kaldırılır ve bu domain için bir daha önerilmez
 */
export const rejectWarning = async (warningId: number, options?: RequestInit): Promise<SuccessResponse> => {

  return customFetch<SuccessResponse>(getRejectWarningUrl(warningId),
  {
    ...options,
    method: 'POST'


  }
);}




export const getRejectWarningMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectWarning>>, TError,{warningId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectWarning>>, TError,{warningId: number}, TContext> => {

const mutationKey = ['rejectWarning'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectWarning>>, {warningId: number}> = (props) => {
          const {warningId} = props ?? {};

          return  rejectWarning(warningId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectWarningMutationResult = NonNullable<Awaited<ReturnType<typeof rejectWarning>>>

    export type RejectWarningMutationError = ErrorType<unknown>

    /**
 * @summary AI önerisini reddet — uyarı kaldırılır ve bu domain için bir daha önerilmez
 */
export const useRejectWarning = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectWarning>>, TError,{warningId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rejectWarning>>,
        TError,
        {warningId: number},
        TContext
      > => {
      return useMutation(getRejectWarningMutationOptions(options));
    }

export const getListGlobalRulesUrl = () => {




  return `/api/admin/rules`
}

/**
 * @summary Tüm evrensel kuralları listele
 */
export const listGlobalRules = async ( options?: RequestInit): Promise<GlobalRule[]> => {

  return customFetch<GlobalRule[]>(getListGlobalRulesUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListGlobalRulesQueryKey = () => {
    return [
    `/api/admin/rules`
    ] as const;
    }


export const getListGlobalRulesQueryOptions = <TData = Awaited<ReturnType<typeof listGlobalRules>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGlobalRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListGlobalRulesQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listGlobalRules>>> = ({ signal }) => listGlobalRules({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listGlobalRules>>, TError, TData> & { queryKey: QueryKey }
}

export type ListGlobalRulesQueryResult = NonNullable<Awaited<ReturnType<typeof listGlobalRules>>>
export type ListGlobalRulesQueryError = ErrorType<unknown>


/**
 * @summary Tüm evrensel kuralları listele
 */

export function useListGlobalRules<TData = Awaited<ReturnType<typeof listGlobalRules>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof listGlobalRules>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getListGlobalRulesQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return { ...query, queryKey: queryOptions.queryKey };
}







export const getCreateGlobalRuleUrl = () => {




  return `/api/admin/rules`
}

/**
 * @summary Yeni evrensel kural oluştur
 */
export const createGlobalRule = async (createGlobalRuleBody: CreateGlobalRuleBody, options?: RequestInit): Promise<GlobalRule> => {

  return customFetch<GlobalRule>(getCreateGlobalRuleUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createGlobalRuleBody)
  }
);}




export const getCreateGlobalRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGlobalRule>>, TError,{data: BodyType<CreateGlobalRuleBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createGlobalRule>>, TError,{data: BodyType<CreateGlobalRuleBody>}, TContext> => {

const mutationKey = ['createGlobalRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createGlobalRule>>, {data: BodyType<CreateGlobalRuleBody>}> = (props) => {
          const {data} = props ?? {};

          return  createGlobalRule(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateGlobalRuleMutationResult = NonNullable<Awaited<ReturnType<typeof createGlobalRule>>>
    export type CreateGlobalRuleMutationBody = BodyType<CreateGlobalRuleBody>
    export type CreateGlobalRuleMutationError = ErrorType<unknown>

    /**
 * @summary Yeni evrensel kural oluştur
 */
export const useCreateGlobalRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createGlobalRule>>, TError,{data: BodyType<CreateGlobalRuleBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createGlobalRule>>,
        TError,
        {data: BodyType<CreateGlobalRuleBody>},
        TContext
      > => {
      return useMutation(getCreateGlobalRuleMutationOptions(options));
    }

export const getUpdateGlobalRuleUrl = (ruleId: number,) => {




  return `/api/admin/rules/${ruleId}`
}

/**
 * @summary Evrensel kuralı güncelle
 */
export const updateGlobalRule = async (ruleId: number,
    updateGlobalRuleBody: UpdateGlobalRuleBody, options?: RequestInit): Promise<GlobalRule> => {

  return customFetch<GlobalRule>(getUpdateGlobalRuleUrl(ruleId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateGlobalRuleBody)
  }
);}




export const getUpdateGlobalRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGlobalRule>>, TError,{ruleId: number;data: BodyType<UpdateGlobalRuleBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateGlobalRule>>, TError,{ruleId: number;data: BodyType<UpdateGlobalRuleBody>}, TContext> => {

const mutationKey = ['updateGlobalRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateGlobalRule>>, {ruleId: number;data: BodyType<UpdateGlobalRuleBody>}> = (props) => {
          const {ruleId,data} = props ?? {};

          return  updateGlobalRule(ruleId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateGlobalRuleMutationResult = NonNullable<Awaited<ReturnType<typeof updateGlobalRule>>>
    export type UpdateGlobalRuleMutationBody = BodyType<UpdateGlobalRuleBody>
    export type UpdateGlobalRuleMutationError = ErrorType<unknown>

    /**
 * @summary Evrensel kuralı güncelle
 */
export const useUpdateGlobalRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateGlobalRule>>, TError,{ruleId: number;data: BodyType<UpdateGlobalRuleBody>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof updateGlobalRule>>,
        TError,
        {ruleId: number;data: BodyType<UpdateGlobalRuleBody>},
        TContext
      > => {
      return useMutation(getUpdateGlobalRuleMutationOptions(options));
    }

export const getDeleteGlobalRuleUrl = (ruleId: number,) => {




  return `/api/admin/rules/${ruleId}`
}

/**
 * @summary Evrensel kuralı sil
 */
export const deleteGlobalRule = async (ruleId: number, options?: RequestInit): Promise<void> => {

  return customFetch<void>(getDeleteGlobalRuleUrl(ruleId),
  {
    ...options,
    method: 'DELETE'


  }
);}




export const getDeleteGlobalRuleMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGlobalRule>>, TError,{ruleId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteGlobalRule>>, TError,{ruleId: number}, TContext> => {

const mutationKey = ['deleteGlobalRule'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteGlobalRule>>, {ruleId: number}> = (props) => {
          const {ruleId} = props ?? {};

          return  deleteGlobalRule(ruleId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteGlobalRuleMutationResult = NonNullable<Awaited<ReturnType<typeof deleteGlobalRule>>>

    export type DeleteGlobalRuleMutationError = ErrorType<unknown>

    /**
 * @summary Evrensel kuralı sil
 */
export const useDeleteGlobalRule = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteGlobalRule>>, TError,{ruleId: number}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof deleteGlobalRule>>,
        TError,
        {ruleId: number},
        TContext
      > => {
      return useMutation(getDeleteGlobalRuleMutationOptions(options));
    }

